import { render } from "./durationPdf.vue?vue&type=template&id=1d01886e"
import script from "./durationPdf.vue?vue&type=script&lang=js"
export * from "./durationPdf.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__